import { render, staticRenderFns } from "./BookingReportStandardHeaderColumnComponent.vue?vue&type=template&id=1b415356&scoped=true&"
import script from "./BookingReportStandardHeaderColumnComponent.vue?vue&type=script&lang=js&"
export * from "./BookingReportStandardHeaderColumnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b415356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b415356')) {
      api.createRecord('1b415356', component.options)
    } else {
      api.reload('1b415356', component.options)
    }
    module.hot.accept("./BookingReportStandardHeaderColumnComponent.vue?vue&type=template&id=1b415356&scoped=true&", function () {
      api.rerender('1b415356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/Report/BookingReportStandardHeaderColumnComponent.vue"
export default component.exports